type Listener<T> = (event: T) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class TypedEventEmitter<EventMap extends Record<string, any>> {
  private _listeners = new Map<keyof EventMap, Set<Listener<any>>>();

  on<K extends keyof EventMap>(event: K, listener: Listener<EventMap[K]>): this {
    let set = this._listeners.get(event);
    if (!set) {
      set = new Set();
      this._listeners.set(event, set);
    }
    set.add(listener);
    return this;
  }

  off<K extends keyof EventMap>(event: K, listener: Listener<EventMap[K]>): this {
    this._listeners.get(event)?.delete(listener);
    return this;
  }

  once<K extends keyof EventMap>(event: K, listener: Listener<EventMap[K]>): this {
    const wrapped = (e: EventMap[K]) => {
      this.off(event, wrapped);
      listener(e);
    };
    return this.on(event, wrapped);
  }

  protected emit<K extends keyof EventMap>(event: K, data: EventMap[K]): void {
    this._listeners.get(event)?.forEach(fn => fn(data));
  }

  removeAllListeners(event?: keyof EventMap): this {
    if (event) {
      this._listeners.delete(event);
    } else {
      this._listeners.clear();
    }
    return this;
  }
}
